export default __webpack_public_path__ + "static/media/undraw_shopping_app_flsj_(1).cf1d67d9.svg";